import React from "react";
import "./policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1 className="privacy-title">Privacy Policy</h1>

      <div className="privacy-content">
        <h2>Introduction</h2>
        <p>
          This Privacy Policy describes how aaiifa and its affiliates (collectively
          “aaiifa, we, our, us”) collect, use, share, protect or otherwise process
          your information/personal data through our website
          <strong> https://aaiifa.org/ </strong>(hereinafter referred to as “Platform”).
          Please note that you may be able to browse certain sections of the Platform
          without registering with us. We do not offer any product/service under this
          Platform outside India and your personal data will primarily be stored and
          processed in India. By visiting this Platform, providing your information or
          availing any product/service offered on the Platform, you expressly agree to be
          bound by the terms and conditions of this Privacy Policy, the Terms of Use and
          the applicable service/product terms and conditions, and agree to be governed by
          the laws of India including but not limited to the laws applicable to data
          protection and privacy. If you do not agree please do not use or access our
          Platform.
        </p>

        <h2>Collection</h2>
        <p>
          We collect your personal data when you use our Platform, services or otherwise
          interact with us during the course of our relationship. Some of the information
          that we may collect includes but is not limited to personal data/information
          provided to us during sign-up/registering or using our Platform such as name,
          date of birth, address, telephone/mobile number, email ID, and/or any such
          information shared as proof of identity or address. Some sensitive personal data
          may be collected with your consent, such as your bank account or credit/debit
          card or other payment instrument information or biometric information such as
          facial features or physiological information, in accordance with applicable law.
          You always have the option to not provide information by choosing not to use a
          particular service or feature on the Platform.
        </p>
        <p>
          We may track your behaviour, preferences, and other information that you choose
          to provide on our Platform. This information is compiled and analysed on an
          aggregated basis. We will also collect your information related to your
          transactions on the Platform and such third-party business partner platforms.
          When such a third-party business partner collects your personal data directly
          from you, you will be governed by their privacy policies. We shall not be
          responsible for the third-party business partner’s privacy practices or the
          content of their privacy policies, and we request you to read their privacy
          policies prior to disclosing any information.
        </p>
        <p>
          If you receive an email or call from a person/association claiming to be aaiifa
          seeking any personal data like debit/credit card PIN, net-banking or mobile
          banking password, we request you to never provide such information. If you have
          already revealed such information, report it immediately to an appropriate law
          enforcement agency.
        </p>

        <h2>Usage</h2>
        <p>
          We use personal data to provide the services you request. To the extent we use
          your personal data to market to you, we will provide you the ability to opt-out
          of such uses. We use your personal data to assist sellers and business partners
          in handling and fulfilling orders; enhancing customer experience; to resolve
          disputes; troubleshoot problems; inform you about online and offline offers,
          products, services, and updates; customise your experience; detect and protect
          us against error, fraud and other criminal activity; enforce our terms and
          conditions; conduct marketing research, analysis and surveys; and as otherwise
          described to you at the time of collection of information.
        </p>

        <h2>Sharing</h2>
        <p>
          We may share your personal data internally within our group entities, corporate
          entities, and affiliates to provide you access to services and products offered
          by them. These entities and affiliates may market to you unless you explicitly
          opt-out. We may disclose personal data to third parties such as sellers,
          business partners, third-party service providers, logistics partners, payment
          processors, and others. Disclosure may be required to comply with legal
          obligations, enforce agreements, facilitate marketing, or investigate fraud.
          Personal data may also be disclosed to government agencies or law enforcement
          when required by law or in good faith belief that disclosure is necessary.
        </p>

        <h2>Security Precautions</h2>
        <p>
          To protect your personal data from unauthorised access or disclosure, loss or
          misuse we adopt reasonable security practices and procedures. Once your
          information is in our possession, we adhere to security guidelines to protect it
          against unauthorised access. However, the transmission of information is not
          completely secure and users accept the security implications of transmitting
          data over the internet, which cannot always be guaranteed as completely secure.
        </p>

        <h2>Data Deletion and Retention</h2>
        <p>
          You have an option to delete your account by visiting your profile and settings
          on our Platform. You may also write to us for assistance. We may delay deletion
          if there are pending grievances, claims, or other obligations. Once deleted, you
          will lose access to your account. We retain your data only as long as required
          for the purposes it was collected or as required by law, and may retain
          anonymized data for research purposes.
        </p>

        <h2>Your Rights</h2>
        <p>
          You may access, rectify, and update your personal data directly through the
          functionalities provided on the Platform.
        </p>

        <h2>Consent</h2>
        <p>
          By visiting our Platform or by providing your information, you consent to the
          collection, use, storage, disclosure, and processing of your information in
          accordance with this Privacy Policy. You may withdraw your consent by writing to
          the Grievance Officer, though withdrawal may affect your access to services.
        </p>

        <h2>Changes to this Privacy Policy</h2>
        <p>
          Please check our Privacy Policy periodically for updates. We may update this
          Policy to reflect changes to our practices and may notify you about significant
          changes as required under applicable law.
        </p>

        <h2>Grievance Officer</h2>
        <p>
          <strong>Insert Name of the Officer:</strong> <br />
          <strong>Designation:</strong> <br />
          <strong>Insert Name and Address of the Company:</strong> <br />
          <strong>Contact us:</strong> <br />
          Phone: <br />
          Time: Monday – Friday (9:00 – 18:00)
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
